module.exports = __webpack_public_path__ + "img/20250417_1.b6af17e8.png";